window.addEventListener('load', () => {
  const hash = window.location['hash']
  if(hash === '#premium-collection') {
    const target = document.querySelector(hash)
    target.style.paddingTop = '53px'
    target.style.marginTop = '0px'
  }
})
